// Generated on 2026-07-13T21:59:02.059Z
// This file contains preloaded stores data from the API
// Do not edit manually - use 'npm run generate:stores-data' to regenerate

export const preloadedStores: any = [
  {
    "id": "04",
    "name": "San Pedro Sula",
    "address": "Edificio ALLAS Repuestos, Avenida Junior, 2-3 Calle N.E. Barrio Barandillas, San Pedro Sula, Cortés.",
    "city": "San Pedro Sula",
    "regionId": 1,
    "regionLabel": "NORTE",
    "cityCode": 4,
    "phone": "2509-7350",
    "isOpen": false,
    "id_image": "04.webp",
    "coordinates": {
      "lat": 15.506495,
      "lng": -88.01936
    },
    "distance": null,
    "detailedHours": {
      "monday": "8AM - 5PM",
      "tuesday": "8AM - 5PM",
      "wednesday": "8AM - 5PM",
      "thursday": "8AM - 5PM",
      "friday": "8AM - 5PM",
      "saturday": "8AM - 3PM",
      "sunday": "Cerrado"
    },
    "holidayHours": [],
    "services": [
      "battery",
      "oil",
      "electric",
      "maintenance",
      "alternator",
      "brakes"
    ]
  },
  {
    "id": "06",
    "name": "San Pedro Sula Sur",
    "address": "Edificio ALLAS Repuestos, 3ra Avenida y 14 Calle S.O. Barrio Paz Barahona, San Pedro Sula, Cortés.",
    "city": "San Pedro Sula",
    "regionId": 1,
    "regionLabel": "NORTE",
    "cityCode": 4,
    "phone": "2509-7360",
    "isOpen": false,
    "id_image": "06.webp",
    "coordinates": {
      "lat": 15.493933620752,
      "lng": -88.0259692668915
    },
    "distance": null,
    "detailedHours": {
      "monday": "8AM - 5PM",
      "tuesday": "8AM - 5PM",
      "wednesday": "8AM - 5PM",
      "thursday": "8AM - 5PM",
      "friday": "8AM - 5PM",
      "saturday": "8AM - 3PM",
      "sunday": "Cerrado"
    },
    "holidayHours": [],
    "services": [
      "battery",
      "oil",
      "electric",
      "maintenance",
      "alternator",
      "brakes"
    ]
  },
  {
    "id": "07",
    "name": "San Pedro Sula Norte",
    "address": "Edificio ALLAS Repuestos, 3ra Avenida y 10 Calle N.O. Barrio Las Acacias, San Pedro Sula, Cortés.",
    "city": "San Pedro Sula",
    "regionId": 1,
    "regionLabel": "NORTE",
    "cityCode": 4,
    "phone": "2509-7365",
    "isOpen": false,
    "id_image": "07.webp",
    "coordinates": {
      "lat": 15.5135942,
      "lng": -88.0231587
    },
    "distance": null,
    "detailedHours": {
      "monday": "8AM - 5PM",
      "tuesday": "8AM - 5PM",
      "wednesday": "8AM - 5PM",
      "thursday": "8AM - 5PM",
      "friday": "8AM - 5PM",
      "saturday": "8AM - 3PM",
      "sunday": "Cerrado"
    },
    "holidayHours": [],
    "services": [
      "battery",
      "oil",
      "electric",
      "maintenance",
      "alternator",
      "brakes"
    ]
  },
  {
    "id": "15",
    "name": "Choloma",
    "address": "Mall Las Americas, Carretera CA-13, Choloma, Cortés.",
    "city": "San Pedro Sula",
    "regionId": 1,
    "regionLabel": "NORTE",
    "cityCode": 4,
    "phone": "2509-7375",
    "isOpen": false,
    "id_image": "15.webp",
    "coordinates": {
      "lat": 15.6042994,
      "lng": -87.9571911
    },
    "distance": null,
    "detailedHours": {
      "monday": "8AM - 5PM",
      "tuesday": "8AM - 5PM",
      "wednesday": "8AM - 5PM",
      "thursday": "8AM - 5PM",
      "friday": "8AM - 5PM",
      "saturday": "8AM - 3PM",
      "sunday": "Cerrado"
    },
    "holidayHours": [],
    "services": [
      "battery",
      "oil",
      "electric",
      "maintenance",
      "alternator",
      "brakes"
    ]
  },
  {
    "id": "09",
    "name": "El Progreso",
    "address": "ALLAS Repuestos, 2 Calle y 3 Avenida N.E., El Centro, El Progreso 2301.",
    "city": "San Pedro Sula",
    "regionId": 1,
    "regionLabel": "NORTE",
    "cityCode": 4,
    "phone": "2509-7370",
    "isOpen": false,
    "id_image": "09.webp",
    "coordinates": {
      "lat": 15.4010822,
      "lng": -87.812394
    },
    "distance": null,
    "detailedHours": {
      "monday": "8AM - 5PM",
      "tuesday": "8AM - 5PM",
      "wednesday": "8AM - 5PM",
      "thursday": "8AM - 5PM",
      "friday": "8AM - 5PM",
      "saturday": "8AM - 3PM",
      "sunday": "Cerrado"
    },
    "holidayHours": [],
    "services": [
      "battery",
      "oil",
      "electric",
      "maintenance",
      "alternator",
      "brakes"
    ]
  },
  {
    "id": "01",
    "name": "La Ceiba",
    "address": "Edificio ALLAS Repuestos, Avenida 14 de Julio y 11va. Calle, El Centro, La Ceiba, Atlántida.",
    "city": "La Ceiba",
    "regionId": 1,
    "regionLabel": "NORTE",
    "cityCode": 1,
    "phone": "2509-7355",
    "isOpen": false,
    "id_image": "01.webp",
    "coordinates": {
      "lat": 15.782146,
      "lng": -86.789814
    },
    "distance": null,
    "detailedHours": {
      "monday": "8AM - 5PM",
      "tuesday": "8AM - 5PM",
      "wednesday": "8AM - 5PM",
      "thursday": "8AM - 5PM",
      "friday": "8AM - 5PM",
      "saturday": "8AM - 3PM",
      "sunday": "Cerrado"
    },
    "holidayHours": [],
    "services": [
      "battery",
      "oil",
      "electric",
      "maintenance",
      "alternator",
      "brakes"
    ]
  },
  {
    "id": "05",
    "name": "Tegucigalpa",
    "address": "Edificio ALLAS Repuestos, Barrio Guacerique, Bulevar Comunidad Económica Europea, frente a INMECRO.",
    "city": "Tegucigalpa",
    "regionId": 2,
    "regionLabel": "CENTRO-SUR",
    "cityCode": 5,
    "phone": "2283-4541",
    "isOpen": false,
    "id_image": "05.webp",
    "coordinates": {
      "lat": 14.089306,
      "lng": -87.20767
    },
    "distance": null,
    "detailedHours": {
      "monday": "8AM - 5PM",
      "tuesday": "8AM - 5PM",
      "wednesday": "8AM - 5PM",
      "thursday": "8AM - 5PM",
      "friday": "8AM - 5PM",
      "saturday": "8AM - 3PM",
      "sunday": "Cerrado"
    },
    "holidayHours": [],
    "services": [
      "battery",
      "oil",
      "electric",
      "maintenance",
      "alternator",
      "brakes"
    ]
  },
  {
    "id": "13",
    "name": "La Era",
    "address": "ALLAS Repuestos, Anillo Periférico, Colonia La Era, Tegucigalpa.",
    "city": "Tegucigalpa",
    "regionId": 2,
    "regionLabel": "CENTRO-SUR",
    "cityCode": 5,
    "phone": "2283-4565",
    "isOpen": false,
    "id_image": "13.webp",
    "coordinates": {
      "lat": 14.094218,
      "lng": -87.158076
    },
    "distance": null,
    "detailedHours": {
      "monday": "8AM - 5PM",
      "tuesday": "8AM - 5PM",
      "wednesday": "8AM - 5PM",
      "thursday": "8AM - 5PM",
      "friday": "8AM - 5PM",
      "saturday": "8AM - 3PM",
      "sunday": "Cerrado"
    },
    "holidayHours": [],
    "services": [
      "battery",
      "oil",
      "electric",
      "maintenance",
      "alternator",
      "brakes"
    ]
  },
  {
    "id": "14",
    "name": "America",
    "address": "Edificio ALLAS Repuestos, Calle hacia Las Hadas, Colonia America, Tegucigalpa.",
    "city": "Tegucigalpa",
    "regionId": 2,
    "regionLabel": "CENTRO-SUR",
    "cityCode": 5,
    "phone": "2283-4566",
    "isOpen": false,
    "id_image": "14.webp",
    "coordinates": {
      "lat": 14.0517284,
      "lng": -87.2302731
    },
    "distance": null,
    "detailedHours": {
      "monday": "8AM - 5PM",
      "tuesday": "8AM - 5PM",
      "wednesday": "8AM - 5PM",
      "thursday": "8AM - 5PM",
      "friday": "8AM - 5PM",
      "saturday": "8AM - 3PM",
      "sunday": "Cerrado"
    },
    "holidayHours": [],
    "services": [
      "battery",
      "oil",
      "electric",
      "maintenance",
      "alternator",
      "brakes"
    ]
  },
  {
    "id": "11",
    "name": "Kennedy",
    "address": "Bulevar Centro America, Colonia Kennedy, Tegucigalpa.",
    "city": "Tegucigalpa",
    "regionId": 2,
    "regionLabel": "CENTRO-SUR",
    "cityCode": 5,
    "phone": "2283-4555",
    "isOpen": false,
    "id_image": "11.webp",
    "coordinates": {
      "lat": 14.0571551,
      "lng": -87.184669
    },
    "distance": null,
    "detailedHours": {
      "monday": "8AM - 5PM",
      "tuesday": "8AM - 5PM",
      "wednesday": "8AM - 5PM",
      "thursday": "8AM - 5PM",
      "friday": "8AM - 5PM",
      "saturday": "8AM - 3PM",
      "sunday": "Cerrado"
    },
    "holidayHours": [],
    "services": [
      "battery",
      "oil",
      "electric",
      "maintenance",
      "alternator",
      "brakes"
    ]
  },
  {
    "id": "12",
    "name": "Torocagua",
    "address": "Edificio ALLAS Repuestos, Bulevar del Norte, Colonia Torocagua, Contiguo a Gasolinera Puma, Tegucigalpa.",
    "city": "Tegucigalpa",
    "regionId": 2,
    "regionLabel": "CENTRO-SUR",
    "cityCode": 5,
    "phone": "2283-4560",
    "isOpen": false,
    "id_image": "12.webp",
    "coordinates": {
      "lat": 14.0997216,
      "lng": -87.2315389
    },
    "distance": null,
    "detailedHours": {
      "monday": "8AM - 5PM",
      "tuesday": "8AM - 5PM",
      "wednesday": "8AM - 5PM",
      "thursday": "8AM - 5PM",
      "friday": "8AM - 5PM",
      "saturday": "8AM - 3PM",
      "sunday": "Cerrado"
    },
    "holidayHours": [],
    "services": [
      "battery",
      "oil",
      "electric",
      "maintenance",
      "alternator",
      "brakes"
    ]
  },
  {
    "id": "08",
    "name": "Comayaguela",
    "address": "Edificio ALLAS Repuestos, 5ta Avenida y 13 Calle, Comayagüela.",
    "city": "Tegucigalpa",
    "regionId": 2,
    "regionLabel": "CENTRO-SUR",
    "cityCode": 5,
    "phone": "2283-4550",
    "isOpen": false,
    "id_image": "08.webp",
    "coordinates": {
      "lat": 14.092735,
      "lng": -87.209471
    },
    "distance": null,
    "detailedHours": {
      "monday": "8AM - 5PM",
      "tuesday": "8AM - 5PM",
      "wednesday": "8AM - 5PM",
      "thursday": "8AM - 5PM",
      "friday": "8AM - 5PM",
      "saturday": "8AM - 3PM",
      "sunday": "Cerrado"
    },
    "holidayHours": [],
    "services": [
      "battery",
      "oil",
      "electric",
      "maintenance",
      "alternator",
      "brakes"
    ]
  }
];

export default preloadedStores;
